/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Step3_DescInputs */

const en_keyword_optimizer_step3_desc = /** @type {(inputs: Keyword_Optimizer_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the suggestions below, then copy the ones you like into your resume editor.`)
};

const de_keyword_optimizer_step3_desc = /** @type {(inputs: Keyword_Optimizer_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfe die Vorschläge unten und kopiere die passenden in deinen Lebenslauf-Editor.`)
};

const fr_keyword_optimizer_step3_desc = /** @type {(inputs: Keyword_Optimizer_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passez en revue les suggestions ci-dessous, puis copiez celles qui vous plaisent dans votre éditeur de CV.`)
};

const es_keyword_optimizer_step3_desc = /** @type {(inputs: Keyword_Optimizer_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa las sugerencias a continuación y copia las que te gusten en tu editor de CV.`)
};

const it_keyword_optimizer_step3_desc = /** @type {(inputs: Keyword_Optimizer_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla i suggerimenti qui sotto, poi copia quelli che preferisci nel tuo editor del CV.`)
};

const nl_keyword_optimizer_step3_desc = /** @type {(inputs: Keyword_Optimizer_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk de suggesties hieronder en kopieer de gewenste naar je CV-editor.`)
};

const pl_keyword_optimizer_step3_desc = /** @type {(inputs: Keyword_Optimizer_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejrzyj sugestie poniżej, a następnie skopiuj te, które Ci odpowiadają, do edytora CV.`)
};

const fi_keyword_optimizer_step3_desc = /** @type {(inputs: Keyword_Optimizer_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkista alla olevat ehdotukset ja kopioi mieleisesi ansioluetteloeditoriin.`)
};

const da_keyword_optimizer_step3_desc = /** @type {(inputs: Keyword_Optimizer_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemgå forslagene nedenfor, og kopiér dem du kan lide ind i din CV-editor.`)
};

const sv_keyword_optimizer_step3_desc = /** @type {(inputs: Keyword_Optimizer_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Granska förslagen nedan och kopiera de du gillar till din CV-redigerare.`)
};

/**
* | output |
* | --- |
* | "Review the suggestions below, then copy the ones you like into your resume editor." |
*
* @param {Keyword_Optimizer_Step3_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_step3_desc = /** @type {((inputs?: Keyword_Optimizer_Step3_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Step3_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_step3_desc(inputs)
	if (locale === "fr") return fr_keyword_optimizer_step3_desc(inputs)
	if (locale === "es") return es_keyword_optimizer_step3_desc(inputs)
	if (locale === "it") return it_keyword_optimizer_step3_desc(inputs)
	if (locale === "nl") return nl_keyword_optimizer_step3_desc(inputs)
	if (locale === "pl") return pl_keyword_optimizer_step3_desc(inputs)
	if (locale === "fi") return fi_keyword_optimizer_step3_desc(inputs)
	if (locale === "da") return da_keyword_optimizer_step3_desc(inputs)
	if (locale === "sv") return sv_keyword_optimizer_step3_desc(inputs)
	return en_keyword_optimizer_step3_desc(inputs)
});